import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

// Callables defined in functions/marketing/index.js. Each is admin-checked
// server-side and writes adminLogs.
const call = (name, options) => async (data) => (await httpsCallable(functions, name, options)(data)).data;

// Mirror the Cloud Functions' own timeoutSeconds (functions/marketing/index.js)
// so the client doesn't give up on a slow but still-running call before the
// function itself would.
export const runMarketingNow = call('marketingRunNow', { timeout: 300000 });
export const collectMarketingNow = call('marketingCollectNow', { timeout: 540000 });
export const approveMarketingItem = (itemId) => call('marketingApproveItem')({ itemId });
export const skipMarketingItem = (itemId, reason) => call('marketingSkipItem')({ itemId, reason });
export const updateMarketingSettings = (patch) => call('marketingUpdateSettings')({ patch });
export const editMarketingItem = (itemId, fields) => call('marketingEditItem')({ itemId, fields });
export const neverContactMarketing = (itemId) => call('marketingNeverContact')({ itemId });
export const markMarketingTarget = (itemId, outcome) => call('marketingMarkTarget')({ itemId, outcome });
export const retryMarketingSend = (itemId) => call('marketingRetrySend')({ itemId });
export const researchMarketingNow = call('marketingResearchNow', { timeout: 540000 });
export const sendMarketingNow = call('marketingSendNow', { timeout: 120000 });
